/*
 * Public API Surface of pepperi-lib/field-title
 */
export * from './field-title.module';
export * from './field-title.component';
